// Default Locations routes
export default [
  {
    path: 'default-locations',
    name: 'default-locations',
    redirect: 'default-locations/index',
    component: () =>
      import(
        /* webpackChunkName: "defaultLocations" */ '../views/defaultLocations/DefaultLocations.vue'
      ),
    children: [
      {
        path: 'index',
        name: 'defaultLocations',
        meta: {
          tabbable: true,
          tableKeys: ['defaultLocations'],
          filterKeys: ['defaultLocations'],
          formKeys: ['defaultLocations'],
          routePermissions: ['analysisLocationView'],
        },
        component: () =>
          import(
            /* webpackChunkName: "defaultLocationsIndex" */ '../views/defaultLocations/DefaultLocationsIndex.vue'
          ),
      },
    ],
  },
];
